import { Trans } from "react-i18next";
import { IconTiktok } from "@icons/dark/index";
import { IconLineDownload, IconLineLoading } from "@kalodata/kds-design-icons";
import { DownloadVideo } from "@components/DownloadVideo";
import { useTikTokAccounts } from "@pages/me/hooks/useTikTokAccounts";
import { useSerializeCallback } from "@kalodata/tools";
import { enableTiktokEntry } from "@utils/enableTiktokEntry";
import { TestId } from "@shared/testIds";

export type ExportMenuDownloadProps = {
  videoURL?: string;
  videoId: string;
  videoSource?: string;
  kalo_type?: string;
  onDownload?: () => void;
};

export type GeneratedDetailExportMenuContentProps = {
  download: ExportMenuDownloadProps;
  onClose: () => void;
  onOpenPostModal: () => void;
};

export const GeneratedDetailExportMenuContent = ({
  download,
  onClose,
  onOpenPostModal,
}: GeneratedDetailExportMenuContentProps) => {
  const getTikTokAccounts = useTikTokAccounts();
  const post2TikTok = useSerializeCallback(async () => {
    onClose();
    await getTikTokAccounts();
    onOpenPostModal();
  });

  return (
    <div className="flex w-[180px] flex-col gap-[4px] p-[6px]">
      <DownloadVideo {...download} className="w-full flex">
        {(isDownloading) => (
          <button
            type="button"
            data-testid={TestId.LibraryGeneratedVideoDownload}
            aria-busy={isDownloading}
            className="flex-1 flex h-[32px] cursor-pointer items-center gap-[6px] rounded-[8px] border-0 bg-transparent px-[8px] py-[6px] text-left hover:bg-kds-bg-overlay"
          >
            {isDownloading ? (
              <IconLineLoading
                size={20}
                data-testid={TestId.LibraryGeneratedVideoDownloadLoading}
                className="shrink-0 text-kds-fg animate-spin"
              />
            ) : (
              <IconLineDownload size={20} className="shrink-0 text-kds-fg" />
            )}
            <span className="text-[14px] leading-[20px] text-kds-fg">
              <Trans>Download</Trans>
            </span>
          </button>
        )}
      </DownloadVideo>
      {enableTiktokEntry() && (
        <button
          type="button"
          data-testid={TestId.LibraryGeneratedVideoPostToTikTok}
          onClick={post2TikTok}
          className="flex h-[32px] cursor-pointer items-center gap-[6px] rounded-[8px] border-0 bg-transparent px-[8px] py-[6px] text-left hover:bg-kds-bg-overlay"
        >
          <span className="flex size-[20px] shrink-0 items-center justify-center rounded-[4px] bg-black">
            <IconTiktok width={14} height={14} />
          </span>
          <span className="text-[14px] leading-[20px] text-kds-fg">
            <Trans>Post to TikTok</Trans>
          </span>
        </button>
      )}
    </div>
  );
};
